<script>
    import {
        VpCalendarIcon,
        VpMapPinIcon,
        VpRunIcon,
    } from '@decathlon-experience/icons/svelte';
    import { VpRefreshIcon } from '@decathlon-experience/icons/svelte';

    import { FilterType } from '$saga/views/Search/types';
    import Button from '$saga/components/Button.svelte';
    import SecondaryFilters from '$saga/views/Search/SecondaryFilters.svelte';
    import { filtersContext } from '$saga/views/Search/store';

    export let trigger, handleSelectedFilter;
</script>

<div class="relative m-auto hidden h-[42px] max-w-layout-max desktop:block">
    <div class="absolute top-[-42px] w-full px-5xl">
        <div class="border border-solid border-bord-quiet bg-white px-s py-m">
            <div class="flex gap-s">
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.SPORT);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.theme.length > 0}
                        <span
                            class="flex items-center gap-xs text-content-brand"
                        >
                            <VpRunIcon class="size-l" />
                            Sport ({$filtersContext.formLabels.theme.length})
                        </span>
                        <span class="text-xs text-content-quiet">Modifier</span>
                    {:else}
                        <span class="flex items-center gap-xs">
                            <VpRunIcon class="size-l" />
                            Sport
                        </span>
                        <span class="text-xs text-content-quiet">Ajouter</span>
                    {/if}
                </button>
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.DESTINATION);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.destination.length > 0}
                        <span
                            class="flex items-center gap-xs text-content-brand"
                        >
                            <VpMapPinIcon class="size-l" />
                            Destination ({$filtersContext.formLabels.destination
                                .length})
                        </span>
                        <span class="text-xs text-content-quiet">Modifier</span>
                    {:else}
                        <span class="flex items-center gap-xs">
                            <VpMapPinIcon class="size-l" />
                            Destination
                        </span>
                        <span class="text-xs text-content-quiet">Ajouter</span>
                    {/if}
                </button>
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.STARTDATE);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.startDate != null}
                        <span
                            class="flex items-center gap-xs text-content-brand"
                            ><VpCalendarIcon class="size-l" />
                            Date de départ (1)
                        </span>
                        <span class="text-xs text-content-quiet">Modifier</span>
                    {:else}
                        <span class="flex items-center gap-xs">
                            <VpCalendarIcon class="size-l" />
                            Date de départ
                        </span>
                        <span class="text-xs text-content-quiet">Ajouter</span>
                    {/if}
                </button>
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.PAX);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.nbPax !== '' && $filtersContext.formLabels.nbPax !== '0'}
                        <span
                            class="flex items-center gap-xs text-content-brand"
                        >
                            <VpCalendarIcon class="size-l" />
                            Voyageurs ({$filtersContext.formLabels.nbPax})
                        </span>
                        <span class="text-xs text-content-quiet">Modifier</span>
                    {:else}
                        <span class="flex items-center gap-xs">
                            <VpCalendarIcon class="size-l" />
                            Voyageurs
                        </span>
                        <span class="text-xs text-content-quiet">Ajouter</span>
                    {/if}
                </button>
                <Button type="submit" form="travel-search-engine-form">
                    {#if $filtersContext.isSubmitting}
                        <VpRefreshIcon class="size-xl animate-spin " />
                    {:else}
                        Rechercher
                    {/if}
                </Button>
                {#if !$filtersContext.isHomePage}
                    <SecondaryFilters />
                {/if}
            </div>
        </div>
    </div>
</div>
